import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin } from 'antd'
import NoticeRibbon from './ribbon'
import SendNotice from './send'

export default function Notice() {
  const [noticeData, setNoticeData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isSendNoticeVisible, setIsSendNoticeVisible] = useState(false)

  const initialConditions = {
    keywords: '',
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getNoticeData = () => {
    axios.post('/admin/notice/record', { 
      keywords: filterValue.keywords,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setNoticeData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'notices': response.data.notices
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getNoticeData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, currentPage])

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">通知消息</div>
            <NoticeRibbon
              filterValue={filterValue} 
              setFilterValue={setFilterValue}
              isAddVisible={() => { setIsSendNoticeVisible(true) }}  
            />
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th>
                      <div className='public-main-style2-title'>标题</div>
                    </th>
                    <th>通知人群</th>
                    <th>发送时间</th>
                  </tr>
                </thead>

                <tbody>
                  {noticeData.notices && (noticeData.notices.length > 0 ? (noticeData.notices.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} style={{ cursor: 'default'}}>
                      <td>
                        <div className='public-main-style2-title'>{item.title}</div>
                      </td>
                      <td>{item.notice_crowd}</td>
                      <td>{item.send_time}</td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='4'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={noticeData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>
      </Spin>

      {isSendNoticeVisible && <SendNotice
        getNoticeData={getNoticeData} 
        isOpen={isSendNoticeVisible} 
        isCancel={() => { setIsSendNoticeVisible(false) }} 
      />}
    </div>
  )
}
